export const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    marginTop: '0',
    height: '100vh',
    background: theme.menu.root(),
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  flex: {
    flex: 1,
  },
  appBar: {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: 'none',
    boxShadow: 'none',
  },
  appBarShift: {
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  // Equal outer columns keep the bot name centred whether or not Home is shown.
  Toolbar: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    columnGap: 16,
    padding: '0 16px 0 116px',
    zIndex: 0,
    background: theme.menu.toolbar,
    boxShadow: '4px 4px 29px rgba(19, 69, 186, 0.0855129)',
    fontFamily: 'Lato, sans-serif',
    ...theme.mixins.toolbar,
  },
  toolbarStart: {
    gridColumn: 1,
    display: 'flex',
    alignItems: 'center',
  },
  toolbarEnd: {
    gridColumn: 3,
    justifySelf: 'end',
    display: 'flex',
    alignItems: 'center',
  },
  // No side menu on a deactivated QCS org — the bar starts at the page edge.
  toolbarNoRail: {
    paddingLeft: 16,
  },
  // With a CTA on the right, the name centres in the gap between the left links and the CTA.
  toolbarWithCta: {
    gridTemplateColumns: 'auto minmax(0, 1fr) auto',
    // The 16px column gap spaces both sides equally, so the trailing link margin must go.
    '& $toolbarStart > :last-child, & $toolbarStart > :last-child > p': { marginRight: 0 },
    '& $title': { justifySelf: 'center', maxWidth: '100%' },
  },
  content: {
    width: 800,
    flexGrow: 1,
    backgroundColor: theme.menu.background(),
    paddingLeft: 40,
    // paddingRight: 12,
    marginTop: 64,
    overflowY: 'auto',
  },
  icon: {
    color: 'grey',
  },
  list: {
    width: 100,
    overflowY: 'auto',
  },
  item: {
    paddingLeft: 16,
  },
  supportAmount: {
    top: 8,
    right: 30,
    borderRadius: 100,
    backgroundColor: theme.defaults.error,
    fontSize: '12px',
    height: 20,
    width: 20,
    color: 'var(--color-white)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
  },
  menuWrap: {
    background: 'var(--color-sidebar)',
    boxShadow: '0px 2px 23px rgba(0, 0, 0, 0.0593014)',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  docLink: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '8px',
    marginBottom: 36,
    '& > span': {
      color: 'var(--color-text-on-primary)',
      fontSize: 12
    }
  },
  listItem: {
    color: 'var(--color-text-on-primary)',
    marginTop: 8,
    marginBottom: 8,
    fontSize: 12
  },
  title: {
    gridColumn: 2,
    fontWeight: 'bold',
    lineHeight: 'normal',
    fontSize: 16,
    color: 'var(--color-text-primary)',
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  link: {
    color: 'var(--color-text-on-primary)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 75,
    paddingTop: 10,
    position: 'relative',
    // CareBrain (master): white stroke only on hover / active — not the default.
    '&:hover': {
      background: 'var(--color-hover-overlay-dark)',
      transition: '0.3s all ease-in',
      '& svg.menu_fill-icon path': {
        fill: 'var(--color-text-on-primary)',
        stroke: 'transparent'
      },
      '& svg path': {
        stroke: 'var(--color-text-on-primary)',
        background: 'rgba(19,69,186,0.5)',
        transition: '0.3s all ease-in',
      },
    },
  },
  activeLink: {
    color: 'var(--color-text-on-primary)',
    background: 'var(--color-hover-overlay-dark)',
    '& svg.menu_fill-icon path': {
      fill: 'var(--color-text-on-primary)',
      stroke: 'transparent'
    },
    '& svg path': {
      stroke: 'var(--color-text-on-primary)'
    },
  },
  alternativeLink: {
    color: 'var(--color-text-on-primary)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 75,
    paddingTop: 10,
    position: 'relative',
    '&:hover': {
      background: 'var(--color-hover-overlay-dark)',
      transition: '0.3s all ease-in',
      '& svg path': {
        fill: 'var(--color-text-on-primary)',
        background: 'rgba(19,69,186,0.5)',
        transition: '0.3s all ease-in',
      },
    },
  },
  alternativeActiveLink: {
    color: 'var(--color-text-on-primary)',
    background: 'var(--color-hover-overlay-dark)',
    '& svg path': {
      fill: 'var(--color-text-on-primary)'
    },
  },
  // QCS-only nav chrome (bar + scale + always-on white icons). Applied on Menu root.
  // Active bar uses &$activeLink under $link so .link.activeLink beats idle scaleY(0).
  qcsChrome: {
    '& $link': {
      transition: 'background 180ms ease',
      '& svg path': {
        stroke: 'var(--color-text-on-primary)',
      },
      '& svg.menu_fill-icon path': {
        fill: 'var(--color-text-on-primary)',
        stroke: 'transparent',
      },
      '& svg': {
        transition: 'transform 200ms cubic-bezier(0.2, 0.8, 0.2, 1)',
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: 3,
        background: 'var(--color-text-on-primary)',
        transform: 'scaleY(0)',
        transformOrigin: 'center',
        transition: 'transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1)',
      },
      '&:hover': {
        background: 'var(--color-hover-overlay-dark)',
        '&::before': { transform: 'scaleY(1)' },
        '& svg': { transform: 'scale(1.1)' },
      },
      '&$activeLink': {
        '&::before': { transform: 'scaleY(1)' },
      },
    },
    '& $alternativeLink': {
      transition: 'background 180ms ease',
      '& svg': {
        transition: 'transform 200ms cubic-bezier(0.2, 0.8, 0.2, 1)',
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: 3,
        background: 'var(--color-text-on-primary)',
        transform: 'scaleY(0)',
        transformOrigin: 'center',
        transition: 'transform 220ms cubic-bezier(0.2, 0.8, 0.2, 1)',
      },
      '&:hover': {
        background: 'var(--color-hover-overlay-dark)',
        '&::before': { transform: 'scaleY(1)' },
        '& svg': { transform: 'scale(1.1)' },
        '& svg path': {
          fill: 'var(--color-text-on-primary)',
        },
      },
      '&$alternativeActiveLink': {
        '&::before': { transform: 'scaleY(1)' },
      },
    },
  },
  backToAnalytics: {
    fontFamily: 'Lato, sans-serif',
    padding: '0',
    margin: '0 24px 0 0',
    cursor: 'pointer',
    fontWeight: 400,
    color: 'var(--color-button-primary)',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  backToQcs: {
    textDecoration: 'none',
    '&:hover, &:focus': {
      color: 'var(--color-button-primary)',
      textDecoration: 'none',
    },
  },
  // The divider supplies the spacing after "Back to home".
  backToQcsBeforeDivider: {
    marginRight: 0,
  },
  // Thin rule between "Back to home" and Home.
  qcsNavDivider: {
    flexShrink: 0,
    width: 2,
    height: 18,
    margin: '0 15px',
    background: 'var(--careco-border, rgba(255,255,255,0.3))',
  },
  homeButton: {
    fontFamily: 'Lato, sans-serif',
    padding: '0',
    margin: '0 24px 0 0',
    cursor: 'pointer',
    fontWeight: 400,
    color: 'var(--color-button-primary)',
  },
  homeButtonQcs: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'opacity 160ms ease',
    '&:hover': { opacity: 0.72 },
  },
  supervisionButton: {
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    height: 38,
    marginRight: 20,
    padding: '0 16px',
    border: 'none',
    borderRadius: 'var(--careco-rounded-sm, 8px)',
    background: '#326668',
    color: '#ffffff',
    fontFamily: 'Lato, sans-serif',
    fontSize: 16,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    textDecoration: 'none',
    cursor: 'pointer',
    boxShadow: '0 1px 2px rgba(15, 61, 60, 0.14)',
    transition: 'background 140ms ease, box-shadow 160ms ease, transform 140ms ease',
    '&:hover:not(:disabled)': {
      transform: 'translateY(-1px)',
      background: '#244d4f',
      boxShadow: '0 6px 18px rgba(15, 61, 60, 0.24)',
    },
    '&:disabled': {
      opacity: 0.55,
      cursor: 'default',
      transform: 'none',
      boxShadow: '0 1px 2px rgba(15, 61, 60, 0.14)',
    },
  },
  testButton: {
    color: 'var(--color-text-on-primary)',
    margin: 0,
    fontWeight: 500,
    fontSize: 16,
    textTransform: 'none',
    fontFamily: 'Lato, sans-serif',
  },
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    padding: '11px',
    paddingBottom: '22px',
    borderBottomWidth: 1,
    borderBottomColor: 'white',
    borderBottomStyle: 'solid',
  },

  // Full-area notice in place of nav + content when a deactivated QCS org is
  // opened — top bar stays so Home remains reachable.
  deactivatedWrap: {
    flexGrow: 1,
    marginTop: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 24px',
    backgroundColor: theme.menu.background(),
    fontFamily: 'Lato, sans-serif',
  },
  deactivatedContent: {
    width: '100%',
    maxWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  deactivatedLogo: {
    width: 82,
    height: 82,
    display: 'block',
    marginBottom: 16,
  },
  deactivatedText: {
    margin: 0,
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    textAlign: 'center',
    color: '#103C56',
  },
})
